import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import cl from './BaseSimplePage.module.css'
import BaseSimpleItemBrowser from "./BaseSimpleItemBrowser";
import BaseSimpleItemEditor from "./BaseSimpleItemEditor";
import ServerManager from "../../API/ServerManager";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";
import AlertSnackbar from "../../components/AlertSnackbar/AlertSnackbar";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";

const BaseSimplePage = forwardRef(({
                              isAddSubMode,
                              modeApiName1,
                              modeApiName2,
                              ItemFormComponent,
                              renderItemEditorFunc,
                              browserStyle,
                              ItemBrowserComponent,
                              browserFilterExtraParams = {},
                              pageOptions = {},
                              testReadOnlyItemFunc,
                          }, ref) => {

    useImperativeHandle(ref, () => ({
        setLoadingOverlayData: setLoadingOverlayData,
        setSnackbarData: setSnackbarData,
        setEditItemId: setEditItemId,
        refreshBrowserItems: itemBrowserRef.current.refreshItems,
    }));

    const DefinedItemBrowserComponent = ItemBrowserComponent ?? BaseSimpleItemBrowser;

    const [filteredItems, setFilteredItems] = useState([]); // текущие загруженные с сервера (с учетом фильтра) итемы (некоторая их часть - страница)
    const [refsData, setRefsData] = useState({});
    const [editItemId, setEditItemId] = useState(0);
    const [searchByIdMode, setSearchByIdMode] = useState(false);
    const [editorKey, setEditorKey] = useState(0);
    const itemBrowserRef = useRef(null);

    // TODO: можно сделать глобальными? обрабатывать в корневом компоненте?
    const [loadingOverlayData, setLoadingOverlayData] = useState(null); // { title }
    const [snackbarData, setSnackbarData] = useState(null); // { severity, title, message }
    const [confirmDialogData, setConfirmDialogData] = useState(null); // { message, confirmLabel, cancelLabel, onAnswer }

    function handleDelete() {
        setConfirmDialogData({
            message: "Вы уверены, что хотите удалить запись?",
            confirmLabel: "Да",
            cancelLabel: "Нет",
            onAnswer: handleDeleteConfirmDialogAnswer,
        })
    };

    async function handleDeleteConfirmDialogAnswer(confirmed) {
        setConfirmDialogData(null);

        if (!confirmed)
            return;

        setLoadingOverlayData({title: "Удаление записи"})

        let deleted = false;

        try {
            throw "Функция удаления недоступна!";
            //const response = await ServerManager.deleteSimpleModeItem(modeApiName2, editItemId);
            //deleted = response.count === 1;
            deleted = false;
        } catch (error) {
            setSnackbarData({severity: "error", title: "Ошибка при удалении записи!", message: error});
        }

        setLoadingOverlayData(null);

        if (deleted) {
            setSnackbarData({severity: "success", message: "Запись удалена"});
            setFilteredItems(filteredItems.filter(x => x.id !== editItemId));
            setEditItemId(0);
        }
    }

    async function handleAdd(data) {
        setLoadingOverlayData({title: "Добавление записи"});

        let addedId = 0;

        try {
            const responseData = await ServerManager.addSimpleModeItem(modeApiName1, data);
            addedId = responseData.id;
            console.log("addedId", addedId);
        } catch (error) {
            setLoadingOverlayData(null);
            setSnackbarData({severity: "error", title: "Ошибка при добавлении записи!", message: error});
            return;
        }

        // успешно добавлено

        setLoadingOverlayData(null);
        setSnackbarData({severity: "success", message: "Запись добавлена"});

        setConfirmDialogData({
            message: "Запись успешно добавлена. Очистить форму для создания еще одной записи?",
            confirmLabel: "Да",
            cancelLabel: "Нет",
            onAnswer: handleClearConfirmDialogAnswer,
        })
    }

    async function handleClearConfirmDialogAnswer(confirmed) {
        setConfirmDialogData(null);

        if (!confirmed)
            return;

        setEditorKey(editorKey + 1);
    }

    async function handleSave(data) {
        setLoadingOverlayData({title: "Сохранение записи"})

        try {
            await ServerManager.saveSimpleModeItem(modeApiName1, editItemId, data);
        } catch (error) {
            setLoadingOverlayData(null);
            setSnackbarData({severity: "error", title: "Ошибка при сохранении записи!", message: error});
            return;
        }

        // успешно сохранено

        // обновляем элемент в списке (вдруг изменилось название)
        try {
            //await itemBrowserRef.current.updateItem(editItemId, filteredItems, setFilteredItems);
            itemBrowserRef.current.refreshItems();
        } catch (error) {
            // nothing // данная ошибка не фатальна. все равно сохранение успешно прошло.
        }

        setLoadingOverlayData(null);
        setSnackbarData({severity: "success", message: "Запись сохранена"});
        setEditorKey(editorKey + 1);
    };

    const handleErrorSnackbarClose = (event, reason) => {
        setSnackbarData(null);
    };

    function renderItemEditor(key, props) {
        return renderItemEditorFunc ? renderItemEditorFunc(key, props) : <BaseSimpleItemEditor {...props} key={key}/>
    }

    return (
        <div className={cl.main0}>
            <div className={cl.mainRow}>
                {!isAddSubMode && <div className={cl.browserArea} style={browserStyle}>
                    <DefinedItemBrowserComponent
                        ref={itemBrowserRef}
                        modeApiName2={modeApiName2}
                        filteredItems={filteredItems}
                        setFilteredItems={setFilteredItems}
                        refsData={refsData}
                        setRefsData={setRefsData}
                        selectedItemId={editItemId}
                        setSelectedItemId={setEditItemId}
                        setSearchByIdMode={setSearchByIdMode}
                        setSnackbarData={setSnackbarData}
                        filterExtraParams={browserFilterExtraParams}
                    />
                </div>}
                {(isAddSubMode || editItemId !== 0) && <div className={cl.editorArea}>
                    {renderItemEditor(editItemId + "|" + editorKey,{
                        modeApiName1: modeApiName1,
                        ItemFormComponent: ItemFormComponent,
                        isAddSubMode: isAddSubMode,
                        editItemId: editItemId,
                        searchByIdMode: searchByIdMode,
                        onAdd: handleAdd,
                        onDelete: handleDelete,
                        onSave: handleSave,
                        setSnackbarData: setSnackbarData,
                        setLoadingOverlayData: setLoadingOverlayData,
                        pageOptions: pageOptions,
                        testReadOnlyFunc: testReadOnlyItemFunc,
                    })}
                </div>}
            </div>
            {snackbarData && <AlertSnackbar
                open={true}
                severity={snackbarData.severity}
                title={snackbarData.title}
                message={<div style={{whiteSpace:"pre-line"}}>{snackbarData.message}</div>}
                onClose={handleErrorSnackbarClose}
            />}
            {loadingOverlayData && <LoadingOverlay
                open={true}
                title={loadingOverlayData.title}
            />}
            {confirmDialogData && <ConfirmDialog
                open={true}
                message={confirmDialogData.message}
                confirmLabel={confirmDialogData.confirmLabel}
                cancelLabel={confirmDialogData.cancelLabel}
                onAnswer={confirmDialogData.onAnswer}
            />}
        </div>
    );
});

export default BaseSimplePage;